import { loadCatalog } from './data/catalog';
import { RadioScene } from './scene/RadioScene';
import { AudioEngine } from './audio/AudioEngine';
import { Social } from './ui/social';
import { PlayerUI } from './ui/PlayerUI';

const host = document.getElementById('app');
if (!host) throw new Error('#app not found');
const appEl: HTMLElement = host;

async function main(): Promise<void> {
  // админка эфира — отдельный lazy-бандл, без тяжёлой 3D-сцены
  if (location.hash === '#admin') {
    const { mountAdmin } = await import('./admin/AdminPanel');
    await mountAdmin();
    return;
  }
  const catalog = await loadCatalog(60);
  const audio = new AudioEngine();
  const scene = new RadioScene(appEl, catalog, audio);
  // обложки — прогрессивно, не блокируя первый кадр
  catalog.loadCovers(scene.renderer.capabilities.getMaxAnisotropy());

  const social = new Social();
  new PlayerUI(scene, catalog, audio, social);

  scene.start();
  // debug-хук для verify-скриптов: текущие FFT-сигналы (bass/beat/…)
  (window as unknown as { __pfmSig?: () => unknown }).__pfmSig = () => audio.signals();
  console.log(`SCENE_OK tracks=${catalog.tracks.length} N=${catalog.N}`);
}

void main();

// PWA: регистрируем service worker (offline-оболочка, установка на устройство)
if ('serviceWorker' in navigator) {
  addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* SW не критичен — приложение работает и без него */
    });
  });
}
